import LocomotiveScroll from "locomotive-scroll";
import { isSafari, preloadImages, preloadFonts } from "./utils";
import Cursor from "./cursor";
import { TextLinesReveal } from "./textLinesReveal";

if (!isSafari) {
  // I don't want to use LocomotiveScroll in Safari for now as it has too many bugs
  // I think because of how Safari handles initial transforms with relative values
  const lscroll = new LocomotiveScroll({
    el: document.querySelector<HTMLElement>("[data-scroll-container]") as
      | HTMLElement
      | undefined,
    smooth: true,
    direction: "vertical",
  });
}

const textLinesReveal = new TextLinesReveal([
  document.querySelector<HTMLElement>(".project__hero-title"),
]);

const revealText = () => {
  textLinesReveal.in();
};

Promise.all([
  preloadImages(".project__section-imginner"),
  preloadFonts("zkq2mjw"),
]).then(() => {
  document.body.classList.remove("loading");
  revealText();

  // Initialize custom cursor
  const cursor = new Cursor(
    document.querySelector<HTMLElement>(".cursor"),
    document.querySelector<HTMLElement>(".cursor__outline")
  );

  // Mouse effects on all links and others
  [...document.querySelectorAll("a.project__footer-link")].forEach((link) => {
    link.addEventListener("mouseenter", () => cursor.enter());
    link.addEventListener("mouseleave", () => cursor.leave());
  });
});
